import { gql } from 'graphql-request'

export const GlobalApplyPageQuery = gql`
  query GlobalApplyPage(
    $locale: LocaleInputType!
    $isPreview: Boolean! = false
  ) {
    ApplyPage(locale: $locale, draft: $isPreview) {
      title
      content ${fragmentBlocksQuery}
    }
  }
`
